var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon clone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.154,
    height: 20.154,
    viewBox: "0 0 20.154 20.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clone",
    d: "M17.812,0H5.528A1.843,1.843,0,0,0,3.685,1.843V3.685H1.843A1.843,1.843,0,0,0,0,5.528V17.812a1.843,1.843,0,0,0,1.843,1.843H14.127a1.843,1.843,0,0,0,1.843-1.843V15.969h1.843a1.843,1.843,0,0,0,1.843-1.843V1.843A1.843,1.843,0,0,0,17.812,0ZM13.9,17.812H2.073a.23.23,0,0,1-.23-.23V5.758a.23.23,0,0,1,.23-.23H3.685v8.6a1.843,1.843,0,0,0,1.843,1.843h8.6v1.612A.23.23,0,0,1,13.9,17.812Zm3.685-3.685H5.758a.23.23,0,0,1-.23-.23V2.073a.23.23,0,0,1,.23-.23H17.581a.23.23,0,0,1,.23.23V13.9A.23.23,0,0,1,17.581,14.127Z",
    transform: "translate(0.25 0.25)",
    fill: "#181a3a",
    stroke: "#181a3a",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.6c69584429374b3c7d91c3095158083f.svg";
export { ForwardRef as ReactComponent };